"use client";

import React from "react";
import { useRouter } from "next/navigation";
import Icon from "@/components/ui/Icon";

interface BlogBackButtonProps {
  slug: string;
  page?: number;
}

export default function BlogBackButton({ slug, page = 1 }: BlogBackButtonProps) {
  const router = useRouter();

  // Construct target return URL with clean pagination and anchor hash.
  // We strictly do NOT auto-apply category filter so the full catalog is preserved,
  // honoring user manual filtering only.
  const params = new URLSearchParams();
  if (page > 1) {
    params.set("page", page.toString());
  }
  const qs = params.toString();
  const targetUrl = qs ? `/blog?${qs}#post-${slug}` : `/blog#post-${slug}`;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    router.push(targetUrl);
  };

  return (
    <a
      href={targetUrl}
      onClick={handleClick}
      className="inline-flex items-center gap-2 text-primary font-bold hover:underline mb-10 cursor-pointer select-none group transition-all"
      aria-label="Back to blog articles grid"
    >
      <Icon
        name="arrow_back"
        size={20}
        className="transition-transform group-hover:-translate-x-1"
        aria-hidden="true"
      />
      <span>Back to Blog</span>
    </a>
  );
}
